import Sidebar from "@/components/Sidebar";

export default function Layout({ children }) {
  return (
    <div className="flex min-h-screen text-white grain">
      <Sidebar />
      <main className="flex-1 min-w-0 relative z-10">{children}</main>
    </div>
  );
}
